import { render, staticRenderFns } from "./visualization.vue?vue&type=template&id=54bebc84&scoped=true"
import script from "./visualization.vue?vue&type=script&lang=js"
export * from "./visualization.vue?vue&type=script&lang=js"
import style0 from "./visualization.vue?vue&type=style&index=0&id=54bebc84&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bebc84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54bebc84')) {
      api.createRecord('54bebc84', component.options)
    } else {
      api.reload('54bebc84', component.options)
    }
    module.hot.accept("./visualization.vue?vue&type=template&id=54bebc84&scoped=true", function () {
      api.rerender('54bebc84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistic/product/components/visualization.vue"
export default component.exports